import { render, staticRenderFns } from "./VineyardGasMetricTable.vue?vue&type=template&id=3db8fa2c&scoped=true&"
import script from "./VineyardGasMetricTable.vue?vue&type=script&lang=js&"
export * from "./VineyardGasMetricTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db8fa2c",
  null
  
)

export default component.exports